// src/services/ImpersonationService.js

/**
 * Manages impersonation state throughout the application
 */
const ImpersonationService = {
    /**
     * Sets the impersonation state
     * @param {Object} impersonationData - Data about the current impersonation
     * @param {number} impersonationData.impersonatedId - The ID of the employee being impersonated
     * @param {string} impersonationData.impersonatedName - The name of the employee being impersonated
     */
    setImpersonation(impersonationData) {
      if (impersonationData) {
        sessionStorage.setItem('impersonation', JSON.stringify(impersonationData));
        // Also store in our standardized format for the context
        sessionStorage.setItem('impersonationData', JSON.stringify({
          impersonatedId: impersonationData.impersonatedId,
          firstName: impersonationData.impersonatedName?.split(' ')[0] || '',
          lastName: impersonationData.impersonatedName?.split(' ')[1] || ''
        }));
      } else {
        sessionStorage.removeItem('impersonation');
        sessionStorage.removeItem('impersonationData');
        sessionStorage.removeItem('pendingImpersonation');
      }
    },
  
    /**
     * Gets the current impersonation state
     * @returns {Object|null} The current impersonation data or null if not impersonating
     */
    getImpersonation() {
      const impersonationData = sessionStorage.getItem('impersonation');
      return impersonationData ? JSON.parse(impersonationData) : null;
    },
  
    /**
     * Clears the current impersonation state
     */
    clearImpersonation() {
      sessionStorage.removeItem('impersonation');
      sessionStorage.removeItem('impersonationData');
      sessionStorage.removeItem('pendingImpersonation');
    },
  
    /**
     * Checks if currently impersonating
     * @returns {boolean} True if currently impersonating, false otherwise
     */
    isImpersonating() {
      return !!this.getImpersonation();
    },
  
    /**
     * Adds impersonation parameters to API requests if needed
     * @param {string} url - The original API URL
     * @returns {string} URL with impersonation parameters if needed
     */
    getImpersonatedApiUrl(url) {
      const impersonation = this.getImpersonation();
      if (impersonation && impersonation.impersonatedId) {
        // If URL already has parameters, add impersonation as additional parameter
        if (url.includes('?')) {
          return `${url}&impersonateId=${impersonation.impersonatedId}`;
        }
        // Otherwise add as first parameter
        return `${url}?impersonateId=${impersonation.impersonatedId}`;
      }
      return url;
    }
  };
  
  export default ImpersonationService;